<script>
import Layout from '@layouts/journey2.vue'
import BaseButtonAngle from '@/src/components/_base-button-angle.vue'
import SubNav from '@/src/components/sub-nav.vue'
import PopOver from '@/src/components/pop-over.vue'

export default {
  page: {
    title: '02 00 Planning Overvie',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Overvie page.' },
    ],
  },
  components: { Layout, BaseButtonAngle, SubNav, PopOver },
}
</script>

<template>
  <Layout>
    <SubNav>
      <BaseButtonAngle clip-side="Right" click-active="inactive">
        <span>Path 02 - 01</span><br />
        Planning
      </BaseButtonAngle>
    </SubNav>
    <BaseHotspot
      :pos-x="61"
      :pos-y="15"
      pos-unit="%"
      :rot-x="57"
      spot-active="inactive"
    />
    <BaseHotspot
      :pos-x="85"
      :pos-y="16"
      pos-unit="%"
      :rot-x="57"
      spot-active="inactive"
    />
    <router-link :to="{ name: 'planning-locationa' }">
      <BaseHotspot :pos-x="24" :pos-y="26" pos-unit="%" :rot-x="57" />
    </router-link>
    <router-link :to="{ name: 'planning-locationa' }">
      <BaseHotspot :pos-x="58" :pos-y="70" pos-unit="%" :rot-x="57" />
    </router-link>
    <PopOver
      :pos-x="38"
      :pos-y="35"
      pos-unit="%"
      pop-size="md"
      pop-height="200px"
    >
      <h1 class="m-t-5 m-b-15 p-b-15" style="border-bottom: solid 2px #fff;"
        >02 - 01 | Planning</h1
      >
      <h3 class="m-t-5" style="font-weight: normal;">
        From strategic to operational plans, Hexagon improves your efficiency
        with a seamless flow of information.
      </h3>
    </PopOver>
    <router-link :to="{ name: 'planning-locationa' }">
      <BaseButton class="z-5" style="position: absolute; top: 60%; left: 45%;">
        ENTER
      </BaseButton>
    </router-link>
  </Layout>
</template>
